import { writable } from 'svelte/store';

export const title = writable('');

export function setTitle(newTitle: string) {
  title.set(newTitle);
}
